module.exports = __webpack_public_path__ + "static/img/VARESE-OAK.d1cea89.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/VARESE-OAK.png
// module id = 5TkL
// module chunks = 0